import React from 'react'

import * as Icons from '@desenvolvimento-intuix/ui-icons'

import * as S from './styles'

interface IHeaderToggle {
  selectedTitle: string | JSX.Element
  toggle: boolean
  onToggle: () => void
}

export const HeaderToggle: React.FC<IHeaderToggle> = ({
  selectedTitle = 'Menu',
  toggle,
  onToggle
}) => {
  return (
    <S.Header>
      <h1>{selectedTitle}</h1>

      <S.Toggle {...{ onClick: onToggle, toggle }} type='button'>
        <Icons.ChevronDown />
      </S.Toggle>
    </S.Header>
  )
}
